export const DEFAULT_LIST_PAGE_SIZE = 25;
export const ADDRESSES_LIST_LIMITED_PAGE_SIZE = 5;
